import Vue from 'vue';
import VueMoment from 'vue-moment';
import moment from 'moment';
require('moment/locale/pt-br');

Vue.use(VueMoment, {
  moment,
});

export default Vue;